<div *ngIf="lang === 'en'"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Privacy Notice & Terms & Conditions
    </h1>
    <p class="mt-3"
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Latest Update 27 Semptember 2024
    </p>
    <div class="mt-4 mb-3" (click)="clickGroup('privacy')"
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Privacy Notice
        <img src="assets/img/chevron-up.png" id="privacy-icon-up" class="float-end d-block" />
        <img src="assets/img/chevron-down.png" id="privacy-icon-down" class="float-end d-none" />
    </div>
    <ul id="privacy-point" class="d-block">
        <li>
            EN Lorem isum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsumdolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit amet
        </li>
    </ul>

    <div class="mt-4 mb-3" (click)="clickGroup('tnc')"
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Terms & Condition
        <img src="assets/img/chevron-up.png" id="tnc-icon-up" class="float-end d-none" />
        <img src="assets/img/chevron-down.png" id="tnc-icon-down" class="float-end d-block" />
    </div>
    <ul id="tnc-point" class="d-none">
        <li>
            EN Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet
        </li>
        <li>
            EN Lorem isum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsumdolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit amet
        </li>
        <li>
            EN Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit amet
        </li>
    </ul>
</div>

<div *ngIf="lang === 'id'"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Pemberitahuan Privasi & Syarat & Ketentuan
    </h1>
    <p class="mt-3"
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Pembaruan Terbaru 27 Semptember 2024
    </p>
    <div class="mt-4 mb-3" (click)="clickGroup('privacy')"
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Pemberitahuan Privasi
        <img src="assets/img/chevron-up.png" id="privacy-icon-up" class="float-end d-block" />
        <img src="assets/img/chevron-down.png" id="privacy-icon-down" class="float-end d-none" />
    </div>
    <ul id="privacy-point" class="d-block">
        <li>
            ID Lorem isum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsumdolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit amet
        </li>
    </ul>
    <div class="mt-4 mb-3" (click)="clickGroup('tnc')"
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Syarat & Ketentuan
        <img src="assets/img/chevron-up.png" id="tnc-icon-up" class="float-end d-none" />
        <img src="assets/img/chevron-down.png" id="tnc-icon-down" class="float-end d-block" />
    </div>
    <ul id="tnc-point" class="d-none">
        <li>
            ID Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet
        </li>
        <li>
            ID Lorem isum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsumdolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit amet
        </li>
        <li>
            ID Lorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit
            ametLorem ipsum dolor sit amet
        </li>
    </ul>
</div>